
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.583 7.375l1.75 1.75m0 0l-1.75 1.75m1.75-1.75H5.667M15 5.042v8.231a.519.519 0 01-.518.519H1.583A.584.584 0 011 13.208V3.292a.583.583 0 01.583-.584h3.889c.126 0 .249.041.35.117L8 4.458h6.417a.583.583 0 01.583.584z","stroke":"#4A4A4A","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    